import { FormField } from './field';
import { FieldControl } from '@signature-it/ngx-generic/enums';
import { FormFieldFactory } from "./field-factory";

export class ConfirmationField extends FormField {
	controlType = FieldControl.CONFIRMATION_FIELD;
	ngxComponentHtml: string;
	fieldsList: [];
	optionsJs:string;

	constructor(attributes?: Object) {
		super(attributes);
		this.ngxComponentHtml = `<ngx-entity-block fall-back-entity-var="default" entity-type-var="block_confirmation_fields" entity-var="${this.cngId}"></ngx-entity-block>`;
		this.fieldsList = attributes['fieldsList'] ||  [];
		this.optionsJs = attributes['optionsJs'] || null;
		this.updateValuesByOtherAns = true;
	}

	getFieldList() {
		let formFields: FormField[] = [];
		let hiddenQuestionId = +(this.questionId + 0.01).toFixed(2);
		this.fieldsList.forEach(hiddenField => {
			formFields.push(FormFieldFactory.createHiddenField(hiddenField, {
				questionId: hiddenQuestionId,
				parentStepHasDependRule: this.parentStepHasDependRule
			}));
			hiddenQuestionId = +(hiddenQuestionId + 0.01).toFixed(2);
		});
		//add validation indicate field
		formFields.push(FormFieldFactory.createHiddenField(this.getIsValidKey(), {
			questionId: hiddenQuestionId,
			ignoreInAns: true,
			required: true,
			value: "true"
		}));
		return formFields;
	}

	getIsValidKey() {
		return this.key + '_is_valid';
	}

	public static getIsValidKey(key) {
		return key + '_is_valid';
	}
}
